<script setup lang="ts">
// メールアドレス入力インプット
interface Props {
  modelValue: string;
  id?: string;
  label?: string;
  label2?: string;
  placeholder?: string;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  id: "email",
  label: "メールアドレス",
  label2: "",
  placeholder: "メールアドレスを入力",
  required: false,
});

const emit = defineEmits<{
  "update:modelValue": [modelValue: string];
}>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

// メールアドレスのパターン
const pattern = /^[a-zA-Z0-9-_\.]+@[a-zA-Z0-9-_\.]+$/;

const isError = ref(false);

function validate() {
  // 必須でなくて値がないとき
  if (!props.required && !props.modelValue) {
    isError.value = false;
    return true;
  }
  // (必須ではないが値はある || 必須で値がない || 必須で値がある) && テストに失敗
  if (!pattern.test(props.modelValue)) {
    isError.value = true;
    return false;
  }

  // テストに合格
  isError.value = false;
  return true;
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el" class="w-full tablet:max-w-[50%] relative pb-6">
    <FormInputLabel :label="label" :label2="label2" :id="id" />
    <MInput
      v-model="localValue"
      class="w-full block rounded p-2"
      :placeholder="placeholder"
      type="email"
      :id="id"
      :color="isError ? 'error' : 'normal'"
    />
    <FormAlert
      type="error"
      class="flex items-center absolute bottom-0"
      v-if="isError"
    >
      <Icon class="mr-1 text-sm" size="18" name="mdi:alert-circle" />
      <span>有効なアドレスをご入力ください</span>
    </FormAlert>
  </div>
</template>

<style scoped>
.mail {
  @apply relative px-2 py-4 md:max-w-[350px];
}
</style>
